import React from 'react';
import { Box, ShimmerBox } from '@common-fe/common-fe';
import _ from 'lodash';
const PreloaderServiceItem = () => {
  const getRandWidth = () => `${_.random(35, 80)}%`;
  return (
    <Box direction="row">
      <ShimmerBox height="20px" round="checkboxRound" width="20px" />
      <ShimmerBox height="20px" round="checkboxRound" width={getRandWidth()} margin={{ left: 'spacing8' }} />
    </Box>
  );
};

export default PreloaderServiceItem;
